<ng-container *transloco="let convert;">
  <div class="print-vdp container">
    <div class="print-vdp__header mb-4">
      <ng-content *ngTemplateOutlet="title"></ng-content>
    </div>

    <div class="row mb-4">
      <div class="col-sm-8">
        @if (images && images.length > 0) {
          <img [src]="images[0].url" alt="{{convert('sellModule.details.printVdp.mainImage')}}" class="w-100" />
        } @else {
          <div class="w-100">
            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 521.06 310.91">
              <defs>
                <style>
                  .cls-1 {
                  fill: #231f20;
                }
                .cls-2 {
                fill: #cecece;
              }
              .cls-3 {
              fill: #dbdbdb;
            }
            .cls-4 {
            fill: #b5b5b5;
          }
          .cls-5,
          .cls-9 {
          fill: none;
        }
        .cls-5 {
        stroke: #a3a3a3;
      }
      .cls-10,
      .cls-5,
      .cls-6 {
      stroke-miterlimit: 10;
    }
    .cls-6 {
    fill: #fff;
  }
  .cls-10,
  .cls-6 {
  stroke: #dbdbdb;
  stroke-width: 4px;
}
.cls-10,
.cls-7 {
fill: #eaeaea;
}
.cls-8 {
fill: #424143;
}
.cls-9 {
stroke: #424143;
stroke-linecap: round;
stroke-linejoin: round;
stroke-width: 1.1px;
}
</style>
</defs>
<title>car_placeholder</title>
<path class="cls-1" d="M69.8,93.38" transform="translate(-66.96 -81.92)" />
<path
  class="cls-2"
  d="M113.36,346s-43,4.52-46.34,13,126.52,39.76,204.46,32.88,112.32-17,112.32-17l38.52-23.4,150-43.85L538.06,267.3,456,284.41Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M91.1,237.71c5.68,1.67,18.18-.79,18.18-0.79l0.83-1.21"
  transform="translate(-66.96 -81.92)"
  />
<path class="cls-3" d="M103.06,206.6" transform="translate(-66.96 -81.92)" />
<path
  class="cls-4"
  d="M327.55,338l28.73-16.31c0-4,2.19-18.18,4.76-28.75,2.23-9.17,10.87-62.89,41.27-61.28C427.57,233,433,271.48,433,271.48c4.92,14.5,3.14,26.54,2.5,34.8s-2.35,64.16-48.39,68.61c-44.22,4.28-53.62-19.94-53.62-19.94A65,65,0,0,1,327.55,338Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M96.88,329.12s5.64,22.06,40.17,22.56c27.84,0.4,36.3-14.7,36.3-14.7"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M367.84,270.55c1.28-1.81,10.28-17.93,25.05-17.52,17.78,0.48,36.83,25.58,33.62,62.84s-26.12,45.72-34.69,45.92c-18.44.43-29.33-18.13-33-43.31a67,67,0,0,1-.57-13l3.4-14.66s0.8-5.14,1.61-6l0.8-3.93Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-4"
  d="M533.21,273.93c1.69,0,4.11-1.09,5.44-1.45s1.86,2.8,2.22,2.08,2.93,1.75,4,1.27,0-12,3.25-29,3.65-50.33,23.27-51.86c17.92-1.4,16.46,46.51,15.49,67.54s-5.2,32.14-5.2,32.14c-6,16.07-13.17,16.31-24.16,16.55s-19.57-.89-25-3.7c-7.8-4-10.47-15.23-10.47-15.23s-2-10.52-1.72-13.65S533.21,273.93,533.21,273.93Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M570.87,228.43c3.14,0,13.27,4,12.2,38.06-0.95,30.2-11.06,34.93-14,34.92-3.87,0-14.71,1.1-12.79-36.49C557.88,233.52,565.57,228.43,570.87,228.43Z"
  transform="translate(-66.96 -81.92)"
  />
<path class="cls-5" d="M557.27,309.61" transform="translate(-66.96 -81.92)" />
<path
  class="cls-6"
  d="M584.09,199.89c-0.68-5.16.28-23.11-.58-27.7s-6.59-11.84-8.88-15.85-6.69-7.83-10.32-13.37l-22.92-35s-8.21-10.7-48.52-19.1-157.21-3.63-157.21-3.63-45.46-.38-75.84,13.18-74.31,53.49-74.31,53.49l-3.82,3.63s-28.08,8-30.95,9.17-9.93,1.72-13.37,2.1S114.46,171.42,98.79,184,73,229.21,71.67,236.56c-7.55,41.7,8.14,91.51,10.19,96.51s273.91,23.78,274.43,5.75,3.7-53.41,16.89-81.48c11.37-24.18,27.52-24.11,27.52-24.11s19.48-1.14,26.49,19C435,270.31,436,308.27,436,308.27l108.89-32.44s4.22-77.84,27-78.81c0,0,7.27,0,10.27,9S586,218.67,586,218.67,584.77,205,584.09,199.89ZM428.43,102.72c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Zm118.94,25.95c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-7"
  d="M537.57,111.76c-0.76-1-3.82-2.55-3.82-2.55l-18-5.6c-18-5.6-29.54-5.48-29.54-5.48s-20.76-1.4-28.14,1.53-14.65,14.14-16.81,18c-1.24,2.25-5.35,10.21-8.88,17.33l7.1,24.72,11-.19a5.3,5.3,0,0,1,2.89,2.44l29-2.87s30.95-3.57,39.22-4.58,11.72-4.71,13.5-6.49,11.33-18.08,12.23-19.39-0.89-4.94-.89-4.94Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-7"
  d="M420.41,96.73l-49.28-1.4-63.42.76-38,1.54c-32.22,12.1-75.83,54.49-75.83,54.49l2.8,2.93s16.81,0.64,30.18.64,57.05,0.64,57.05.64l97.68,1.4,15.79-2.42s28.4-46.74,31.07-52.59S420.41,96.73,420.41,96.73Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M336.42,92.34C292.87,93.87,271.86,96,271.86,96s-4.58,0-17.77,7.45-34,22.73-40.69,28.46S187.24,155,187.24,155s-5.48,4.39-.64,5.41c10.33,2.17,25.66,1.08,25.66,1.08s110.22,2.29,127.41,2.1,43.89-2,50.31-2.7,14.26-2.27,19.51-12,15.2-27.89,19.87-36.29,11.16-18.34,11.16-18.34S380,90.81,336.42,92.34Zm92,10.38c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Z"
  transform="translate(-66.96 -81.92)"
  />
<polygon class="cls-3" points="470.3 63.2 470.3 63.2 470.3 63.2 470.3 63.2" />
<polygon class="cls-3" points="475.24 55.28 475.24 55.28 475.23 55.29 475.24 55.28" />
<path
  class="cls-3"
  d="M523.56,106l3,5.66c3,5.66,8,18.15,9.89,23.37a20.14,20.14,0,0,1,.77,10.06h0l4.94-7.92h0L526.6,107Z"
  transform="translate(-66.96 -81.92)"
  />
<path class="cls-3" d="M481,97.89h0Z" transform="translate(-66.96 -81.92)" />
<path class="cls-3" d="M487.12,98.15l-2.22-.09,1.35,0.08h0.88Z" transform="translate(-66.96 -81.92)" />
<path class="cls-3" d="M504.6,156.57h0Z" transform="translate(-66.96 -81.92)" />
<path
  class="cls-3"
  d="M488.18,98.44l-0.09-.25-1,0h-0.88l-1.35-.08L481,97.89h0s3.82,12.54,8.09,28.64a228.66,228.66,0,0,1,5.81,31.16l9.67-1.12h0.07A211.65,211.65,0,0,0,498,128.95C493.41,113.9,488.86,100.43,488.18,98.44Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M188,139.52c-2.67,1.66-1.24,11.3-1.24,11.3l17.91-15.23C195.23,135,190.67,137.87,188,139.52Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M547.63,123s-5.47-7.64-8.34-11.85-9.49-6.2-9.49-6.2c-12.35-5.35-32.08-8.5-32.08-8.5-9.48-1.53-27-3.06-35.61-1.81s-16,9.17-18.58,13.18-17.52,33-17.52,33C421.24,150,422.58,167,422.58,167v2.67l14-.48,0.48-2.2s5.6,0.11,38.78-2.1c5.73-.38,7.17-4.59,7.17-4.59l40.52-4.48a19.78,19.78,0,0,0,13.25-7.74l2-3s8.69-14.2,9.93-16.46S547.63,123,547.63,123Zm-0.25,5.67c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M454.66,161.88a8.78,8.78,0,0,0,1.54.12l24.58-2.1a6.18,6.18,0,0,0,2.77-.89l-1.12.13Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M437,152.89v0.64c0.88,5.09,1.67,6.24,1.67,6.24l0.89,0L437,151.16A8.63,8.63,0,0,0,437,152.89Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M450.53,159.56h-0.41c1.58,0.22,2,1,2.7,1.59A5.18,5.18,0,0,0,450.53,159.56Z"
  transform="translate(-66.96 -81.92)"
  />
<path
  class="cls-3"
  d="M487.52,145.83a11.11,11.11,0,0,0-9.55-7.74c-7.9-1.05-18.72-.48-24.07,0s-11,4.87-14.14,7.74a8.69,8.69,0,0,0-2.72,5.34l2.47,8.59c2,0,6.9-.14,9.29-0.24a7.22,7.22,0,0,1,1.31.05h0.41a5.18,5.18,0,0,1,2.29,1.6,2.69,2.69,0,0,0,.34.23,4.68,4.68,0,0,0,1.5.49l27.77-2.75,1.12-.13C488.6,155.88,487.52,145.83,487.52,145.83Z"
  transform="translate(-66.96 -81.92)"
  />
<path class="cls-8" d="M98.52,205.69" transform="translate(-66.96 -81.92)" />
<path class="cls-1" d="M98.52,205.69" transform="translate(-66.96 -81.92)" />
<path class="cls-8" d="M102.8,207.53" transform="translate(-66.96 -81.92)" />
<path class="cls-9" d="M117.7,232.17" transform="translate(-66.96 -81.92)" />
<path
  class="cls-10"
  d="M73.42,231.5c11.19,7.23,19.94,10.57,54,14.45,2.65,14.58,32.78,14.76,49.2,15.26s36.82,1.86,42.15-8.8c37.14,0,74-3.4,101.11-11.52,27.32-8.18,31.17-18.62,35.21-39.08-53.2,15.08-228.65,26.65-265.37-6.89C89.71,194.92,77.81,213.69,73.42,231.5Z"
  transform="translate(-66.96 -81.92)"
  />
</svg>
</div>
}
</div>
<div class="col-sm-4 px-0">
  <lib-auction-detail
  ></lib-auction-detail>
</div>
</div>
<div class="container">
  <div class="row mb-4">
    <div class="col-8">
      <lib-vehicle-detail
      ></lib-vehicle-detail>
    </div>
    <div class="col-4">
      <ng-content *ngTemplateOutlet="tabFocus === 1 ? nadaBookValue : blackBookValue;"></ng-content>
    </div>
  </div>
</div>
<div class="container">
  <div class="row mt-2 pt-4 mb-2">
    <div class="col">
      <div class="border-top"></div>
    </div>
  </div>
  <div class="row">
    <div class="col mb-4">
      <app-detail-carousel
        [options]="options$ | async"
        [variant]="showHeading ? 'static' : 'carousel'"
        [limit]="maxEquipRows"
        [detailCarouselTranslate]="detailCarouselData">
      </app-detail-carousel>
    </div>
  </div>
  <div class="row my-2 my-4">
    <div class="col">
      <div class="border-top"></div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-md-8">
      <lib-condition-disclosures
      ></lib-condition-disclosures>
    </div>
    <div class="col-md-4">
      <lib-seller-update
      ></lib-seller-update>
      <lib-seller-location class="mt-4"
      ></lib-seller-location>
    </div>
  </div>
  <div class="print-vdp__images">
    <h3 class="text-uppercase fw-bold h5">{{convert('sellModule.details.printVdp.photos')}}</h3>
    <div class="row">
      @for (image of images; track image) {
        <div class="image-wrapper">
          <img [src]="image.url" alt="" class="me-4 my-4" />
        </div>
      }
    </div>
  </div>
</div>
</div>

<ng-template #title>
  <div class="print-vdp__header--wrapper wrapper d-flex align-items-end">
    <h1 id="" class="m-0 p-0">{{ vehicleInfo.title }}</h1>
    <p class="p-0 m-0 ms-2">
      {{ vehicleInfo.description }}
      {{ vehicleInfo.vin }}
    </p>
  </div>
</ng-template>


<ng-template #blackBookValue>
  <div class="print-vdp__book-value">
    <h3 class="print-vdp__book-value--title text-uppercase fw-bold h5">{{convert('sellModule.details.printVdp.bookValues')}}</h3>
    <div class="print-vdp__book-value--content p-3">
      <div class="book-value-header border-bottom py-1">Black Book</div>
      <div class="book-value-content d-flex flex-column mt-3">
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Wholesale Clean</div>
          <div class="book-value-content__value">
            @if (blackBookValues && blackBookValues.WholesaleClean?.valueAmount) {
              ${{ blackBookValues.WholesaleClean.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Wholesale Average</div>
          <div class="book-value-content__value">
            @if (blackBookValues && blackBookValues.WholesaleAverage?.valueAmount) {
              ${{ blackBookValues.WholesaleAverage.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Wholesale Rough</div>
          <div class="book-value-content__value">
            @if (blackBookValues && blackBookValues.WholesaleRough?.valueAmount) {
              ${{ blackBookValues.WholesaleRough.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Finance Advance</div>
          <div class="book-value-content__value">
            @if (blackBookValues && blackBookValues.FinanceAdvance?.valueAmount) {
              ${{ blackBookValues.FinanceAdvance.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Average Trade-In</div>
          <div class="book-value-content__value">
            @if (blackBookValues && blackBookValues['AverageTrade-In']?.valueAmount) {
              ${{ blackBookValues['AverageTrade-In']?.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nadaBookValue>
  <div class="print-vdp__book-value">
    <h3 class="print-vdp__book-value--title text-uppercase fw-bold h5">{{convert('sellModule.details.printVdp.bookValues')}}</h3>
    <div class="print-vdp__book-value--content p-3">
      <div class="book-value-header border-bottom py-1">J.D. Power</div>
      <div class="book-value-content d-flex flex-column mt-3">
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Trade-In Clean</div>
          <div class="book-value-content__value">
            @if (nadaValues && nadaValues['Trade-InClean']?.valueAmount) {
              ${{ nadaValues['Trade-InClean']?.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Trade-In Average</div>
          <div class="book-value-content__value">
            @if (nadaValues && nadaValues['Trade-InAverage']?.valueAmount) {
              ${{ nadaValues['Trade-InAverage']?.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Trade-In Rough</div>
          <div class="book-value-content__value">
            @if (nadaValues && nadaValues['Trade-InRough']?.valueAmount) {
              ${{ nadaValues['Trade-InRough']?.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Retail Clean</div>
          <div class="book-value-content__value">
            @if (nadaValues && nadaValues.RetailClean?.valueAmount) {
              ${{ nadaValues.RetailClean.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
        <div class="d-flex flex-row justify-content-between mb-2">
          <div class="book-value-content__label">Loan Clean</div>
          <div class="book-value-content__value">
            @if (nadaValues && nadaValues.LoanClean?.valueAmount) {
              ${{ nadaValues.LoanClean.valueAmount | number }}
            } @else {
              <dd class="value mb-0" [id]="id">N/A</dd>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

</ng-container>
